// TanStack Query cache keys for admin/plans.
export const adminPlanKeys = {
  all: ["admin", "plans"] as const,
  list: (limit: number, offset: number) =>
    ["admin", "plans", "list", limit, offset] as const,
  detail: (planId: string) => ["admin", "plans", planId] as const,
  analytics: () => ["admin", "plans", "analytics"] as const,
  salesHistory: (planId: string, params: Record<string, unknown>) =>
    ["admin", "plans", planId, "sales-history", params] as const,
};
